<template>
  <div class="about-us">
    <div class="introduce-main container">
      <div class="view-overlay"></div>
      <div class="header-bottom">
        <div class="line-style">
          <span class="dot"></span>
          <span class="lines"></span>
        </div>
        <div class="font-size">
          <div class="text">{{contentText.aboutUs&&contentText.aboutUs.aboutUsText}}</div>
          <div class="letter">{{contentText.aboutUs&&contentText.aboutUs.aboutUsLatter}}</div>
        </div>
        <div class="line-style">
          <span class="lines"></span>
          <span class="dot"></span>
        </div>
      </div>
      <div class="item item1">
        <div class="item-height">
          <div class="item-title">{{contentText.aboutUs&&contentText.aboutUs.beecargoIntroduce.title}}</div>
          <div class="item-content item-content1">· 小蜂蜂闪运为深圳市中永物流有限公司旗下中永智慧科技(深圳)有限公司最新推出的产品，集聚了25年物流服务的经验精华，安全管控的关键方法，规模级运输项目的优化设计等行业先进理念。为了让更多的客户使用到优质安全的运输服务， 公司把链条长、多变的运输服务进行拆解然后重新组合成标准化的服务，更安全、更高效、更省钱！</div>
          <div class="item-content">· 高度信息化TMS、VMI、SCM、GPS、EDI、全程移动手机APP可视监管职能技术应用，减少人力与时间成本，更有助于实现“零失误”标准化运作，ISO持续改进体系，保证任何地点、时间、不同服务窗口都能有一样出色的物流服务。</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  props: ['contentText'],
  methods: {

  }
}
</script>

<style lang="scss" scoped>
.about-us {
  background: url('../../assets/homepages/about-bg.png');
  background-size: 100% 100%;
  position: relative;
  .view-overlay {
    width: 100%;
    height: 100%;
    background-color: #190D02;
    opacity: 0.5;
    position: absolute;
    top: 0;
    left: 0;
  }
  .header-bottom {
    width: 100%;
    height: 150px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    z-index: 2;

    .line-style {
      height: 10px;
      display: flex;
      align-items: center;
      flex: 1;
      span {
        display: inline-block;
        background: #ffffff;
        opacity: 1;
      }
      .dot {
        width: 9px;
        height: 9px;
        border-radius: 50%;
      }
      .lines {
        flex: 1;
        height: 1px;
      }
    }
    .font-size {
      margin: 0 20px;
      .text,
      .letter {
        // font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-family: PingFangSC;
        font-weight: 400;
        color: #ffffff;
      }
      .text {
        font-size: 40px;
      }
      .letter {
        font-size: 20px;
      }
    }
  }
  .introduce-main {
    width: 100%;
    height: 650px;
    .item {
      flex: 1;
      height: 100%;
      margin-top: 40px;
      position: relative;
      z-index: 2;
    }
    .item-height {
      display: flex;
      align-items: center;
      flex-direction: column;
      .item-title {
        font-size: 28px;
        // font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-family: PingFangSC;
        font-weight: 500;
        color: #ffffff;
        margin-bottom: 30px;
      }
      .item-content {
        width: 100%;
        font-size: 20px;
        text-align: justify;
        // font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-family: PingFangSC;
        font-weight: 400;
        color: #ffffff;
        line-height: 32px;
      }
      .item-content1 {
        margin-bottom: 40px;
      }
    }
  }
  .scope-of-services {
    background: #f5f5f5;
    // height: 223px;
    padding: 40px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .server-title {
      width: 1192px;
      text-align: left;
      span {
        display: inline-block;
      }
      .text-title {
        font-size: 24px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 500;
        color: #f1bc3f;
      }
      .latter-title {
        margin-left: 10px;
        font-size: 14px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #acacac;
      }
    }
    .server-contetn {
      margin-top: 25px;
      width: 1192px;
      text-align: justify;
      font-size: 16px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: #7b7b7b;
    }
  }
}
</style>